import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  hr {
    flex-grow: 1;
    border: none;
    border-top: 1px solid #cecece; /* Adjust color and style as needed */
    margin: 0 10px;
  }
`;
